// Types
import { SocialChannelStatus, SocialMediaPostData } from "@contracts/shareStop";

export function isChannelAuthNeeded(status?: string | null): boolean {
  return status === SocialChannelStatus.AuthNeeded;
}

export function isPostEligibleForApproval(post: SocialMediaPostData): boolean {
  return post.status === "Draft" || post.status === "Unscheduled";
}
